import { render, staticRenderFns } from "./CandidateHiring.vue?vue&type=template&id=239162bc&scoped=true"
import script from "./CandidateHiring.vue?vue&type=script&lang=js"
export * from "./CandidateHiring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239162bc",
  null
  
)

export default component.exports